import React from 'react';
import StyledConnectionWarning from './StyledConnectionWarning';
import { selectOffsetSeconds, selectResponseTime } from '../../features/network/networkSlice';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

const ConnectionWarning: React.FC = () => {
  const offsetSeconds = useSelector(selectOffsetSeconds);
  const responseTime = useSelector(selectResponseTime);

  let className = '';
  let showWarning = false;
  let offLine = false;
  if (offsetSeconds >= 5 || offsetSeconds <= -5) {
    showWarning = true;
    className = 'error';
  }
  if (responseTime > 1000) {
    showWarning = true;
    if (responseTime >= 10000) {
      offLine = true;
      className = 'error';
    } else if (responseTime > 3000) {
      className = 'error';
    }
  }

  if (!showWarning) {
    return <></>;
  }
  return (
    <StyledConnectionWarning className={className}>
      <span className="text">
        {offLine && <FormattedMessage id="header.offLine" />}
        {!offLine && (offsetSeconds >= 5 || offsetSeconds <= -5) && (
          <FormattedMessage id="header.clockOff" values={{ offsetSeconds }} />
        )}
        {!offLine && offsetSeconds < 5 && offsetSeconds > -5 && <FormattedMessage id="header.slowNetwork" />}
      </span>
    </StyledConnectionWarning>
  );
};

export default ConnectionWarning;
